import { CALL_PRIVATE_API } from 'js/constants/api';
import { POST } from 'js/constants/requestMethods';
import * as actionTypes from '../../constants/actionTypes';

export const informEarlyIntent = (id: string) => (dispatch) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.CREATE_EARLY_INTENT_REQUEST,
        actionTypes.CREATE_EARLY_INTENT_SUCCESS,
        actionTypes.CREATE_EARLY_INTENT_FAILURE,
      ],
      endpoint: `/data_credentials/${id}/intent`,
      requestMethod: POST,
      ignoreErrors: true,
    },
  });
};
